var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconBnpl64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_8970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0141 57.3262C45.7157 57.3262 56.8231 46.2189 56.8231 32.5172C56.8231 18.8156 45.7157 7.70819 32.0141 7.70819C18.3125 7.70819 7.20508 18.8156 7.20508 32.5172C7.20508 46.2189 18.3125 57.3262 32.0141 57.3262Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.998 57.3099C24.7637 56.9335 18.7911 54.4142 14.0802 49.752C9.36929 45.0898 7.07901 39.3394 7.20938 32.5009C8.16544 32.5009 10.0723 32.5009 12.9298 32.5009C12.9095 34.5365 12.7091 39.6205 18.2299 45.7833C22.6476 50.7341 28.8069 51.5848 31.998 51.5848C31.9845 52.8463 31.9845 54.7547 31.998 57.3099Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0132 57.3099C39.2475 56.9335 45.2201 54.4142 49.931 49.752C54.6419 45.0898 56.9322 39.3394 56.8018 32.5009C55.8458 32.5009 53.939 32.5009 51.0814 32.5009C51.1017 34.5365 51.3021 39.6205 45.7814 45.7833C41.3637 50.7341 35.2044 51.5848 32.0132 51.5848C32.0268 52.8463 32.0268 54.7547 32.0132 57.3099Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0132 7.69189C39.2475 8.06832 45.2201 10.5876 49.931 15.2498C54.6419 19.912 56.9322 25.6624 56.8018 32.5009C55.8458 32.5009 53.939 32.5009 51.0814 32.5009C51.1017 30.4653 51.3021 25.3813 45.7814 19.2186C41.3637 14.2678 35.2044 13.4171 32.0132 13.4171C32.0268 12.1555 32.0268 10.2471 32.0132 7.69189Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0141 57.3262C45.7157 57.3262 56.8231 46.2189 56.8231 32.5172C56.8231 18.8156 45.7157 7.70819 32.0141 7.70819C18.3125 7.70819 7.20508 18.8156 7.20508 32.5172C7.20508 46.2189 18.3125 57.3262 32.0141 57.3262Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9979 51.5848C42.5377 51.5848 51.0818 43.0407 51.0818 32.5009C51.0818 21.9612 42.5377 13.4171 31.9979 13.4171C21.4582 13.4171 12.9141 21.9612 12.9141 32.5009C12.9141 43.0407 21.4582 51.5848 31.9979 51.5848Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6313 27.4119H24.3643V42.679H39.6313V27.4119Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9976 31.048C36.5498 31.048 36.9976 30.6003 36.9976 30.048C36.9976 29.4957 36.5498 29.048 35.9976 29.048C35.4453 29.048 34.9976 29.4957 34.9976 30.048C34.9976 30.6003 35.4453 31.048 35.9976 31.048Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9976 31.048C28.5498 31.048 28.9976 30.6003 28.9976 30.048C28.9976 29.4957 28.5498 29.048 27.9976 29.048C27.4453 29.048 26.9976 29.4957 26.9976 30.048C26.9976 30.6003 27.4453 31.048 27.9976 31.048Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8147 26.1396C35.8147 24.0317 34.1059 22.3229 31.9979 22.3229C29.89 22.3229 28.1812 24.0317 28.1812 26.1396",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.998 51.5848V57.3099",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.998 7.69189V13.4171",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18896 32.5009H12.9141",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.082 32.5009H56.8072",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_8970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconBnpl64);
export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL64.d752251e908d0f0ebbddef0fa774ced7.svg";
export { ForwardRef as ReactComponent };